"use strict";

import Swiper from 'swiper/bundle';
import scrollCheckSp from "./scrollCheckSp.js";
import headerFix from "./functions/headerFix.js";
import common from "./functions/common.js";

headerFix();
common();

$(() => {

  const a = new scrollCheckSp();
  a.isScrollDown();

  let swiper;
  let calSwiper;

  function initializeSwiper() {
    const homeSwiper = $(".mv-swiper");
    if (homeSwiper.length > 0) {
      swiper = new Swiper(".mv-swiper", {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        speed: 500,
        effect: "fade",
        pagination: {
          el: ".main-visual .swiper-pagination",
          clickable: true,
        },
      });
    }
  }

  function initializeSpSwiper() {
    const calSwiperDom = $(".js-cal .swiper-container");
    if (calSwiperDom.length > 0) {
      calSwiper = new Swiper(".js-cal .swiper-container", {
        loop: false,
        speed: 500,
        pagination: {
          el: ".cal .swiper-pagination",
          clickable: true
        }
      });
    }
  }



  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }

  function destroyPcSwiper() {
    if (calSwiper) {
      calSwiper.destroy();
      console.log('calSwiper', calSwiper)
      calSwiper = undefined;

    }
  }

  function handleResize() {
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (w > 767) {
      if (!swiper) {
        initializeSwiper();
      }
      destroyPcSwiper();
    } else {
      if (!calSwiper) {
        initializeSpSwiper();
      }
      destroySwiper();
    }
  }

  handleResize();
  $(window).on("resize", handleResize)

  const $AnnounceSwiper = $(".announce-swiper .swiper-slide");
  if ($AnnounceSwiper.length > 1) {
    const swiper3 = new Swiper(".announce-swiper", {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      speed: 800,
    });
  }

});


const fadeInTarget = document.querySelectorAll('.js-trigger');
const wid = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
window.addEventListener('scroll', () => {
  for (let i = 0; i < fadeInTarget.length; i++) {
    const rect = fadeInTarget[i].getBoundingClientRect().top;
    let range = 0;
    if (wid < 769) {
      if (fadeInTarget[i].dataset.rangeSp) {
        range = fadeInTarget[i].dataset.rangeSp;
      }
    } else {
      range = fadeInTarget[i].dataset.range;
    }

    if (range > 0) {
      const scroll = window.pageYOffset || document.documentElement.scrollTop;
      const offset = rect + scroll;
      const windowHeight = window.innerHeight;
      const triggerPosition = windowHeight * range / 100;
      if (scroll > offset - windowHeight + triggerPosition) {
        fadeInTarget[i].classList.add('is-active');
      }
    }
  }
});

const breakpoint = 768;
let eSwiper;
let isESwiper = false;

window.addEventListener(
  "load", () => {
    if (breakpoint > wid) {
      equipmentSwiper();
      isESwiper = true;
    }
  }, false
)

window.addEventListener(
  "resize", () => {
    if (breakpoint <= wid && isESwiper) {
      eSwiper.destroy(false, true);
      isESwiper = false;

    } else if (breakpoint > wid && !isESwiper) {
      equipmentSwiper();
      isESwiper = true;
    }
  }, false
)

const equipmentSwiper = () => {
  eSwiper = new Swiper(".equipment-swiper", {
    slidesPerView: "auto",
    spaceBetween: 20,
    centeredSlides: true,
    navigation: {
      nextEl: '.next',
      prevEl: '.prev',
    }
  });
}